<rt-dialog-header
  [heading]="'app.requisitions.assigned_jobs_dialog.heading' | translate"
  [subheading]="
    'app.requisitions.assigned_jobs_dialog.subheading' | translate: { count: offers.length }
  "
/>

<rt-dialog-body>
  <rt-box variant="vertical no-padding">
    <rt-form-field margin-medium margin-bottom-small-xx>
      <rt-input
        [autoFocus]="true"
        [formControl]="searchControl"
        [hasClearButton]="true"
        (reset)="reset()"
        [placeholder]="'app.common.placeholders.search.offers.other' | translate"
        variant="rounded"
      >
        <rt-icon prefix name="search" />
      </rt-input>
    </rt-form-field>
    <rt-tabs margin-left>
      <rt-tab class="active">
        {{ 'app.common.jobs' | translate }}
        <rt-badge color="counter-default" [text]="visibleOffers.length" margin-left-small-x />
      </rt-tab>
    </rt-tabs>
    <rt-divider />

    @if (visibleOffers.length) {
      <div>
        @for (offer of visibleOffers; track trackById($index, offer); let last = $last) {
          <div>
            <div
              layout
              padding-lr
              padding-tb-medium
              [routerLink]="hasAccessToJob(offer.id) ? '/offers/' + offer.slug + '/pipeline' : null"
              class="job-item"
              [class.not-clickable]="!hasAccessToJob(offer.id)"
            >
              <div layout margin-right-small-x>
                <rt-offer-status-indicator
                  margin-top-small-x
                  [offerStatus]="{ kind: 'job', status: offer.status }"
                />
              </div>
              <div layout-vertical>
                <rt-heading padding-right-small>
                  <span class="title">{{ offer.title }} </span>
                  <rt-badge class="transform-none" [text]="'#' + offer.guid!" color="secondary" />
                </rt-heading>
                <p>
                  {{ offer.location }}
                </p>
              </div>
            </div>
            @if (!last) {
              <rt-divider />
            }
          </div>
        }
      </div>
    } @else {
      @if (searchControl.value && !visibleOffers.length) {
        <rt-empty-state
          [title]="'app.common.no_results_found' | translate"
          variant="small"
          icon="search"
          margin
        >
          <rt-button (click)="reset()" variant="tertiary">
            {{ 'app.assignments.editor.clear_search' | translate }}
          </rt-button>
        </rt-empty-state>
      }
    }
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="close()" variant="primary">
    {{ 'app.common.done' | translate }}
  </rt-button>
</rt-dialog-footer>
